module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AM-414a02d81b5ad5e33189bd57c3da5e29.png";